import { useSyncExternalStore } from 'react';

// Tiny store so the axios interceptor and the Genie stream handler (which are not React
// components) can tell the UI that the session expired. Also used by SessionExpiredModal.
let expired = false;
let loginUrl = '/login';
const listeners = new Set<() => void>();

export function notifySessionExpired(url?: string) {
  // Several requests can fail with 401 together; show the notice once.
  if (expired) return;
  expired = true;
  if (url) loginUrl = url;
  listeners.forEach((listener) => listener());
}

export function getLoginUrl() {
  return loginUrl;
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useSessionExpired() {
  return useSyncExternalStore(subscribe, () => expired);
}
